import AsideBar from "./AsideBar";
import VideoContainer from "./VideoContainer";
const Main=()=>{
    return(
        <div className="pt-16 flex">
            <AsideBar/>
            <VideoContainer/>
        </div>
    );
}
export default Main;